module.exports = __webpack_public_path__ + "img/no_task288.15fb4afc.png";